import { adminClient } from "./admin";

export const customersList = async (params = {}) =>
  (await adminClient().get(`/admin/customers`, { params })).data;
export const customersMeta = async () =>
  (await adminClient().get(`/admin/customers/meta`)).data;
export const customerGet = async (id) =>
  (await adminClient().get(`/admin/customers/${id}`)).data;
export const customerJobs = async (id) =>
  (await adminClient().get(`/admin/customers/${id}/jobs`)).data;
export const customerOrders = async (id) =>
  (await adminClient().get(`/admin/customers/${id}/orders`)).data;
export const customerSave = async (id, payload) =>
  id
    ? (await adminClient().patch(`/admin/customers/${id}`, payload)).data
    : (await adminClient().post(`/admin/customers`, payload)).data;
export const customerDelete = async (id) =>
  (await adminClient().delete(`/admin/customers/${id}`)).data;
export const customerSendStatusEmail = async (customerId, payload) =>
  (await adminClient().post(`/admin/customers/${customerId}/status-email`, payload || {})).data;
export const customersMerge = async (keeperId, sourceIds) =>
  (await adminClient().post(`/admin/customers/merge`, { keeper_id: keeperId, source_ids: sourceIds })).data;
export const customersBackfill = async () =>
  (await adminClient().post(`/admin/customers/backfill`)).data;

export const CUSTOMER_TYPE_COLORS = {
  ups_store:     { bg: "#FFB500", fg: "#1C1917", border: "#1C1917", label: "UPS Store" },
  house_account: { bg: "#1E40AF", fg: "#FFFFFF", border: "#1C1917", label: "House Account" },
  retail:        { bg: "#737373", fg: "#FFFFFF", border: "#1C1917", label: "Retail" },
};
